// Shared brand theme tokens (aligned with product page CSS variables in index.css).

export function resolveBrandThemeId(entity, extraKey = "") {
  const slug = String(extraKey || entity?.slug || "").toLowerCase();
  const name = String(entity?.name || entity?.title || "").toLowerCase();
  const url = String(entity?.url || "").toLowerCase();
  const key = `${slug} ${name} ${url}`;

  if (key.includes("sensaphone")) return "sensaphone";
  if (key.includes("picobox")) return "picobox";
  if (key.includes("raychem") || key.includes("tracetek")) return "raychem";
  return "default";
}

export const BRAND_THEME_CLASSES = {
  default: {
    icon: "text-green-600",
    titleHover: "group-hover:text-green-600",
    pdfBadge: "bg-green-600",
    sidebarActive:
      "bg-gradient-to-r from-green-600 to-green-500 text-white font-semibold shadow-md",
    sidebarInactive: "bg-green-50/90 text-gray-800 hover:bg-green-100/90",
    tabActive:
      "relative z-20 -mb-px rounded-t-xl border border-b-0 border-x-green-200/70 border-t-[3px] border-t-green-600 bg-white text-green-800 font-semibold shadow-[0_-4px_16px_rgba(22,163,74,0.1)] px-5 py-2.5 sm:px-6 sm:py-3",
    tabInactive:
      "relative z-10 rounded-t-lg border border-b-0 border-transparent bg-green-100/45 text-green-800/70 font-medium hover:bg-green-50/90 hover:text-green-800 px-4 py-2 sm:px-5 sm:py-2.5",
    panel:
      "panel-elevated relative z-0 rounded-2xl border-t-0 bg-gradient-to-br from-white via-white to-green-50/35 shadow-xl backdrop-blur-md",
    input:
      "w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-lg text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-green-600 focus:border-transparent transition-all duration-200 hover:border-green-500",
    select:
      "w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-green-600 focus:border-transparent transition-all duration-200 cursor-pointer hover:border-green-500",
    cardRowOdd: "bg-green-50/70 border-green-100",
    cardRowEven: "bg-white/95 border-green-200/80",
    cardFallbackIcon: "text-green-600",
  },
  sensaphone: {
    icon: "text-[#1a6fa8]",
    titleHover: "group-hover:text-[#1a6fa8]",
    pdfBadge: "bg-[#1a6fa8]",
    sidebarActive:
      "bg-gradient-to-r from-[#145a88] to-[#3ba8d4] text-white font-semibold shadow-md",
    sidebarInactive:
      "bg-[#eef6fc]/90 text-[#145a88] hover:bg-[#d4eaf7]/90",
    tabActive:
      "relative z-20 -mb-px rounded-t-xl border border-b-0 border-x-[#a8d4ef]/60 border-t-[3px] border-t-[#1a6fa8] bg-white text-[#145a88] font-semibold shadow-[0_-4px_16px_rgba(26,111,168,0.12)] px-5 py-2.5 sm:px-6 sm:py-3",
    tabInactive:
      "relative z-10 rounded-t-lg border border-b-0 border-transparent bg-[#d4eaf7]/45 text-[#145a88]/70 font-medium hover:bg-[#eef6fc]/95 hover:text-[#145a88] px-4 py-2 sm:px-5 sm:py-2.5",
    panel:
      "panel-elevated relative z-0 rounded-2xl border-t-0 bg-gradient-to-br from-white via-white to-[#eef6fc]/50 shadow-xl backdrop-blur-md ring-1 ring-[#a8d4ef]/25",
    input:
      "w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-lg text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#1a6fa8] focus:border-transparent transition-all duration-200 hover:border-[#3ba8d4]",
    select:
      "w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#1a6fa8] focus:border-transparent transition-all duration-200 cursor-pointer hover:border-[#3ba8d4]",
    cardRowOdd: "bg-[#eef6fc]/80 border-[#d4eaf7]",
    cardRowEven: "bg-white/95 border-[#a8d4ef]/70",
    cardFallbackIcon: "text-[#1a6fa8]",
  },
  picobox: {
    icon: "text-[#2b3990]",
    titleHover: "group-hover:text-[#2b3990]",
    pdfBadge: "bg-[#2b3990]",
    sidebarActive:
      "bg-gradient-to-r from-[#222d73] to-[#3d52b8] text-white font-semibold shadow-md",
    sidebarInactive:
      "bg-[#eef0f8]/90 text-[#222d73] hover:bg-[#d4d9ef]/90",
    tabActive:
      "relative z-20 -mb-px rounded-t-xl border border-b-0 border-x-[#a8b2de]/60 border-t-[3px] border-t-[#2b3990] bg-white text-[#222d73] font-semibold shadow-[0_-4px_16px_rgba(43,57,144,0.12)] px-5 py-2.5 sm:px-6 sm:py-3",
    tabInactive:
      "relative z-10 rounded-t-lg border border-b-0 border-transparent bg-[#d4d9ef]/45 text-[#222d73]/70 font-medium hover:bg-[#eef0f8]/95 hover:text-[#222d73] px-4 py-2 sm:px-5 sm:py-2.5",
    panel:
      "panel-elevated relative z-0 rounded-2xl border-t-0 bg-gradient-to-br from-white via-white to-[#eef0f8]/50 shadow-xl backdrop-blur-md ring-1 ring-[#a8b2de]/25",
    input:
      "w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-lg text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#2b3990] focus:border-transparent transition-all duration-200 hover:border-[#3d52b8]",
    select:
      "w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#2b3990] focus:border-transparent transition-all duration-200 cursor-pointer hover:border-[#3d52b8]",
    cardRowOdd: "bg-[#eef0f8]/80 border-[#d4d9ef]",
    cardRowEven: "bg-white/95 border-[#a8b2de]/70",
    cardFallbackIcon: "text-[#2b3990]",
  },
  raychem: {
    icon: "text-[#9e2129]",
    titleHover: "group-hover:text-[#9e2129]",
    pdfBadge: "bg-[#9e2129]",
    sidebarActive:
      "bg-gradient-to-r from-[#7d1a21] to-[#b8323c] text-white font-semibold shadow-md",
    sidebarInactive:
      "bg-[#fceeed]/90 text-[#7d1a21] hover:bg-[#f5d4d6]/90",
    tabActive:
      "relative z-20 -mb-px rounded-t-xl border border-b-0 border-x-[#e8a8ad]/60 border-t-[3px] border-t-[#9e2129] bg-white text-[#7d1a21] font-semibold shadow-[0_-4px_16px_rgba(158,33,41,0.12)] px-5 py-2.5 sm:px-6 sm:py-3",
    tabInactive:
      "relative z-10 rounded-t-lg border border-b-0 border-transparent bg-[#f5d4d6]/50 text-[#7d1a21]/70 font-medium hover:bg-[#fceeed]/95 hover:text-[#7d1a21] px-4 py-2 sm:px-5 sm:py-2.5",
    panel:
      "panel-elevated relative z-0 rounded-2xl border-t-0 bg-gradient-to-br from-white via-white to-[#fceeed]/50 shadow-xl backdrop-blur-md ring-1 ring-[#e8a8ad]/25",
    input:
      "w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-lg text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#9e2129] focus:border-transparent transition-all duration-200 hover:border-[#c44a52]",
    select:
      "w-full px-4 py-3 bg-white border-2 border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#9e2129] focus:border-transparent transition-all duration-200 cursor-pointer hover:border-[#c44a52]",
    cardRowOdd: "bg-[#fceeed]/80 border-[#f5d4d6]",
    cardRowEven: "bg-white/95 border-[#e8a8ad]/70",
    cardFallbackIcon: "text-[#9e2129]",
  },
};

export function getBrandThemeClasses(themeId) {
  return BRAND_THEME_CLASSES[themeId] || BRAND_THEME_CLASSES.default;
}
